import createMessagesSlice, {
  initialState,
} from '@sv-support-sdk/chat-store/src/modules/messages/slices';
import { resetState } from '@sv-support-sdk/chat-store/src/modules/reset/actions';

export const messagesSlice = createMessagesSlice({
  initialState: { ...initialState },
  reducers: {},
  resetState,
});

export const {
  addMessages,
  deleteMessageByUuid,
  setUnreadMessages,
  addMessage,
  deleteMessageByType,
  setTyping,
  setReplied,
  setReplyToSupport,
  clearTempMessages,
  updateCallbackAnswer,
} = messagesSlice.actions;

export default messagesSlice.reducer;
